import { Howler } from "howler";
import { CommonData } from "../../datastructures/gamestate/gameData";
import { onBetChangeWindow } from "../../functions/Functions_GameBar";
import { Button } from "../buttonsLibrary";
// import { onBetChangeUpDown, onBetChangeWindow } from "../../functions/Functions_GameBar";

export class PortraitMode {
  private parent: PIXI.Container;
  private blackBar: PIXI.Graphics;
  private winBar: PIXI.Graphics;
  private stakeBtn: Button;
  private optionBtn: Button;

  private activeGameData: CommonData;
  private winText: PIXI.Text;
  private balText: PIXI.Text;
  private betText: PIXI.Text;

  private clockDisplay: PIXI.Text;
  private btnPlus: PIXI.Sprite;
  private btnMinus: PIXI.Sprite;
  private s_textStyle: PIXI.TextStyle;
  private m_textStyle: PIXI.TextStyle;
  private l_textStyle: PIXI.TextStyle;

  private muteBtn: Button;
  public enableVisibility: boolean;

  constructor(parent: PIXI.Container, activeGameData: CommonData) {
    this.activeGameData = activeGameData;
    this.parent = new PIXI.Container();
    //    this.parent.alpha=0.1

    if (this.activeGameData.isTableGame == false) {
      parent.addChild(this.parent);
    }

    this.enableVisibility = true;
    this.blackBar = new PIXI.Graphics();
    this.blackBar.beginFill(0x000000);
    this.blackBar.drawRect(0, 210, this.activeGameData.size[0], 420); //210);
    this.blackBar.endFill();

    this.parent.addChild(this.blackBar);

    this.winBar = new PIXI.Graphics();
    this.winBar.beginFill(0x000000);
    this.winBar.drawRect(0, 0, this.activeGameData.size[0], 210); //210);
    this.winBar.endFill();
    this.blackBar.addChild(this.winBar);

    //    this.winBar.alpha=.3;
    this.blackBar.y = this.parent.height - this.blackBar.height;

    this.muteBtn = new Button(
      new PIXI.Sprite(PIXI.Texture.fromImage("icon_soundOn.png")),
      new PIXI.Circle(0, 0, 130)
    );
    this.muteBtn.placeButton(this.blackBar, [
      this.activeGameData.size[0] - 170,
      this.blackBar.height * (2 / 3),
    ]);
    this.muteBtn.setScale(1.5);
    this.muteBtn.setFunction(this.muteBtnClick);

    this.stakeBtn = new Button(
      new PIXI.Sprite(PIXI.Texture.fromImage("betStack.png")),
      new PIXI.Circle(0, 0, 130)
    );
    this.stakeBtn.setScale(2);
    //   this.stakeBtn.placeButton(this.blackBar,[this.blackBar.width-(this.stakeBtn.getImage().width),this.blackBar.height/2]);

    //   this.home=new Button( new PIXI.Sprite( PIXI.Texture.fromImage('icon_Home.png')),new PIXI.Circle(0, 0, 130));
    // //   this.home.setScale(4)
    // this.home.getImage().anchor.set(0)
    //         this.home.placeButton(this.parent,[(this.home.getImage().width)/2,-0]);
    this.s_textStyle = new PIXI.TextStyle({
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 65,
      fill: ["#ffffff"],
      fontWeight: "bold",
      lineHeight: 45,
      stroke: 0x000000,
      strokeThickness: 10,
    });
    this.m_textStyle = new PIXI.TextStyle({
      align: "center",
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 100,
      fill: ["#ffffff"],
      fontWeight: "bold",
      lineHeight: 100,
      stroke: 0x000000,
      strokeThickness: 10,
    });
    this.l_textStyle = new PIXI.TextStyle({
      align: "center",
      fontFamily: this.activeGameData.gameTextStyle.gameFont,
      fontSize: 150,
      fill: ["#ffffff"],
      fontWeight: "bold",
      lineHeight: 150,
      stroke: 0x000000,
      strokeThickness: 10,
    });

    this.optionBtn = new Button(
      new PIXI.Sprite(PIXI.Texture.fromImage("btn_Option.png")),
      new PIXI.Circle(0, 0, 130)
    );
    this.optionBtn.setScale(2);
    this.optionBtn.placeButton(this.blackBar, [
      170,
      this.blackBar.height * (2 / 3),
    ]);
    this.m_textStyle;
    this.winText = new PIXI.Text("WIN : 000", this.l_textStyle);

    this.clockDisplay = new PIXI.Text("TIME : 000", this.m_textStyle);
    this.clockDisplay.scale.set(0.25);
    this.clockDisplay;
    this.clockDisplay.anchor.set(0.5);
    this.clockDisplay.alpha = 0.5;
    this.clockDisplay.y = this.optionBtn.getImage().height / 2;
    // this.optionBtn.getImage().addChild(this.clockDisplay);  //no more needed as it is replaced by the mini game bar with name

    //    this.winText.anchor.set(.5);
    this.winText.anchor.set(0.5, 0);
    this.winText.x = this.blackBar.width / 2;
    this.winText.y = this.winBar.height / 2 - this.winText.height / 2;
    this.blackBar.addChild(this.winText);
    this.setWinValue("0.00");

    this.betText = new PIXI.Text("999.00", this.l_textStyle);
    //    this.betText.anchor.set(.5);
    this.betText.anchor.set(0.5, 0);
    this.betText.x = this.blackBar.width / 2;
    this.betText.y = this.blackBar.height / 2 - this.betText.height / 2;
    this.blackBar.addChild(this.betText);

    this.setWinValue("0.00");

    this.balText = new PIXI.Text("WIN : 000", this.s_textStyle);
    this.balText.anchor.set(0.5, 0);
    //    this.balText.anchor.set(0,.5);
    this.balText.x = this.blackBar.width / 2;
    this.balText.y = this.blackBar.height - this.balText.height * 2 - 50;
    this.blackBar.addChild(this.balText);

    this.setWinValue("0.00");
    this.setBalValue("0.00");
    this.setBetValue("0.00");
    this.btnPlus;
    this.btnMinus;
    this.createBetBtn();

    this.parent.y =
      -this.activeGameData.portraitPlayOffsetTop + window.innerHeight;

    //    this.parent.scale.set(0)
    this.setVisible(false);
  }

  private muteBtnClick = (): void => {
    // console.log(this.activeGameData)
    let newTexture = PIXI.Texture.fromImage("icon_soundOn.png");
    if (this.activeGameData.isAudioMuted) {
      newTexture = PIXI.Texture.fromImage("icon_soundOn.png");
      this.activeGameData.isAudioMuted = false;
      Howler.mute(false);
    } else {
      newTexture = PIXI.Texture.fromImage("icon_soundOff.png");
      this.activeGameData.isAudioMuted = true;
      Howler.mute(true);
    }
    this.muteBtn.setNewTexture(newTexture);
  };

  public setInteractive = (bool: boolean): void => {
    this.optionBtn.setInteractive(bool);
    this.stakeBtn.setInteractive(false);
    // this.btnPlus.interactive= (bool);
    // this.btnPlus.buttonMode= (bool);
    // this.btnMinus.interactive= (bool);
    // this.btnMinus.interactive= (bool);

    this.setBtnMode(this.btnPlus, bool);
    this.setBtnMode(this.btnMinus, bool);
    this.setBtnMode(this.betText, bool);
  };

  public setClockTime = (newTime: string): void => {
    this.clockDisplay.text = newTime;
  };
  public setClockVisible = (bool: boolean): void => {
    if (bool) {
      this.clockDisplay.alpha = 0.5;
    } else {
      this.clockDisplay.alpha = 0;
    }
  };
  public createBetBtn() {
    this.btnPlus = new PIXI.Sprite(PIXI.Texture.fromFrame("icon_add.png"));

    this.btnMinus = new PIXI.Sprite(
      PIXI.Texture.fromFrame("icon_substract.png")
    );

    // //
    this.blackBar.addChild(this.btnPlus);
    this.blackBar.addChild(this.btnMinus);

    this.btnPlus.anchor.set(0.5);
    this.btnMinus.anchor.set(0.5);
    this.btnPlus.scale.set(2);
    this.btnMinus.scale.set(2);

    this.btnPlus.y = this.betText.y + this.btnPlus.height;
    this.btnMinus.y = this.btnPlus.y;

    let offsetFromCenter = 400;
    this.btnPlus.x = this.activeGameData.size[0] / 2 + offsetFromCenter;
    this.btnMinus.x = this.activeGameData.size[0] / 2 - offsetFromCenter;

    this.btnPlus.buttonMode = true;

    let hitArea = new PIXI.Rectangle(-100, -100, 200, 200);
    this.btnPlus.hitArea = hitArea;
    this.btnMinus.hitArea = hitArea;

    // let h=new PIXI.Graphics();
    // h.beginFill(0xff0000);
    // h.drawRect(-0/2,0,this.blackBar.width,  this.betText.height);
    // h.alpha=.5
    // h.endFill();
    // this.blackBar.addChild(h)

    this.setBtnMode(this.btnPlus, true);
    this.setBtnMode(this.btnMinus, true);

    this.setBetFunction();
    this.setBtnMode(this.betText, true);

    this.betText.hitArea = new PIXI.Rectangle(
      -300,
      0,
      600,
      this.betText.height
    );
    let separator_l = new PIXI.Sprite(
      PIXI.Texture.fromFrame("lightSeparator.png")
    );
    separator_l.anchor.set(0.5, 0);
    this.betText.addChild(separator_l);
    separator_l.x = -300;

    let separator_r = new PIXI.Sprite(
      PIXI.Texture.fromFrame("lightSeparator.png")
    );
    separator_r.anchor.set(0.5, 0);
    this.betText.addChild(separator_r);
    separator_r.x = 300;
  }
  public setBetFunction() {
    this.btnPlus.on(
      "pointertap",
      this.activeGameData.betChangeFunction.bind(
        undefined,
        "up",
        this.activeGameData
      )
    );
    this.btnMinus.on(
      "pointertap",
      this.activeGameData.betChangeFunction.bind(
        undefined,
        "down",
        this.activeGameData
      )
    );

    this.betText.on(
      "pointertap",
      onBetChangeWindow.bind(undefined, this.activeGameData)
    );
    // this.btnPlus.on('pointertap', function (e: Event) {
    //     fn();
    //     e.stopPropagation();
    // }.bind(this));
  }
  private setBtnMode = (elem: PIXI.Sprite | PIXI.Text, bool: boolean): void => {
    elem.buttonMode = bool;
    elem.interactive = bool;
  };
  public setWinValue = (newVal: string): void => {
    this.winText.text =
      this.activeGameData.gameTextGeneral.win +
      ": " +
      newVal +
      this.activeGameData.currency;
    // this.winText.text=this.activeGameData.gameTextGeneral.win+': 1000000000.00EUR'
    // set max  width
    if (this.winText.width >= this.blackBar.width - 300) {
      this.winText.width = this.blackBar.width / 4;
    }

    if (newVal == "0.00") {
      this.winText.alpha = 0;
      this.winBar.alpha = 0;
    } else {
      this.winText.alpha = 1;
      this.winBar.alpha = 0.35;
    }
  };
  public setBalValue = (newVal: string): void => {
    this.balText.text =
      this.activeGameData.gameTextGeneral.bal +
      ": " +
      newVal +
      this.activeGameData.currency;

    let mxWidth = this.blackBar.width / 2 - this.optionBtn.getWidth();
    if (this.balText.width > mxWidth) {
      // console.log('true')
      this.balText.width = mxWidth;
    }
  };

  public setBetValue = (newVal: string): void => {
    // newVal
    this.betText.text = newVal; //+this.activeGameData.currency ;
    // this.betText.text= this.activeGameData.gameTextGeneral.bet+":\n"+newVal+this.activeGameData.currency ;
    // this.betText.x=this.blackBar.width/2
    this.betText.y = this.blackBar.height / 2 - this.betText.height / 2;
  };

  public getParent = (): PIXI.Container => {
    return this.parent;
  };

  public setVisible = (bool: boolean): void => {
    // console.log(this.enableVisibility)
    if (bool && this.enableVisibility) {
      this.parent.alpha = 1;
      this.parent.scale.set(1);
      this.activeGameData.gameBar.setPortraitPlay(); //autoplace correct positiom
      this.updateTheHelpPages(true);

      this.setClockVisible(true); //display the  portratit mode clock
      if (this.activeGameData.clock != undefined) {
        this.activeGameData.clock.setMainClockVisible(false);
      }
    } else {
      this.parent.alpha = 0;
      this.parent.scale.set(0);
      this.updateTheHelpPages(false);

      this.setClockVisible(false);
      if (this.activeGameData.clock != undefined) {
        this.activeGameData.clock.setMainClockVisible(true);
      }
    }
    this.gamePortraitScale();
    this.scaleGameMainMask(bool);
  };

  public scaleGameMainMask = (bool: boolean): void => {
    if (bool && this.activeGameData.portraitScalemainMask != 1) {
      // this.activeGameData.mainMaskContainer.scale.set(this.activeGameData.portraitGameSceneScale[1]);
      this.activeGameData.mainMaskContainer.scale.y = this.activeGameData.portraitScalemainMask;
    } else {
      this.activeGameData.mainMaskContainer.scale.set(1);
    }

    // //--apply the same mask to jackpot bg;
    // if(this.activeGameData.jackPotGame!=undefined)
    // {
    //     this.activeGameData.jackPotGame.getBlackBGContainer().height=(window.innerHeight)
    // }
    // console.log( this.activeGameData.mainMaskContainer.scale.y,this.activeGameData.portraitGameSceneScale[1])
  };

  public setPortraitScale = (scaleXY: Array<number>): void => {
    scaleXY;
  };
  public setPortraitOffset = (offsetXY: Array<number>): void => {
    offsetXY;
  };

  private gamePortraitScale = (): void => {
    let screenRatio = window.innerHeight / window.innerWidth;
    let orientationPortrait = window.matchMedia("(orientation: portrait)")
      .matches;
    let verticalMode = false;
    if (
      orientationPortrait &&
      screenRatio >= this.activeGameData.minRatioForPortraitPlay
    ) {
      verticalMode = true;
    }

    //--apply new scale and fix
    if (
      this.activeGameData.isMobile &&
      this.activeGameData.playOnPortrait &&
      verticalMode &&
      this.activeGameData.portraitGameScaleEnable
    ) {
      let scaleX = this.activeGameData.portraitGameSceneScale[0];
      let scaleY = this.activeGameData.portraitGameSceneScale[1];
      let offSetX = this.activeGameData.portraitGameSceneOffset[0];
      let offSetY = this.activeGameData.portraitGameSceneOffset[1];

      this.activeGameData.gameScene.scale.set(
        this.activeGameData.gameScene.scale.y * scaleX * 0.98,
        this.activeGameData.gameScene.scale.y * scaleY * 0.95
      );
      this.activeGameData.gameScene.y =
        this.activeGameData.gameScene.y -
        this.activeGameData.gameResolution[1] / offSetY;
      this.activeGameData.gameScene.x =
        this.activeGameData.gameScene.x -
        this.activeGameData.gameResolution[0] / offSetX;
      //--sceneBG scalign

      this.activeGameData.gameSceneBG.scale.set(
        this.activeGameData.gameScene.scale.x,
        this.activeGameData.gameScene.scale.y
      );
      this.activeGameData.gameSceneBG.y = this.activeGameData.gameScene.y;
      this.activeGameData.gameSceneBG.x = this.activeGameData.gameScene.x;
    }

    ////debug msg size
    // if(this.activeGameData.lowBalanceMessage!=undefined)
    // this.activeGameData.lowBalanceMessage.setMessageBoxVisibile(true)
  };
  private updateTheHelpPages = (bool: boolean): void => {
    if (this.activeGameData.gameOption != undefined) {
      let helppages = this.activeGameData.gameOption.getPages();
      for (let i = 0; i < helppages.length; i++) {
        helppages[i].setTextSizePortrait(bool);
      }
    }
  };
  public setoptionFn = (fn: Function): void => {
    this.optionBtn.setFunction(fn);
  };

  public setBetFn = (fn: Function): void => {
    this.stakeBtn.setFunction(fn);
  };
}
